module.exports = __webpack_public_path__ + "assets/close-darkBlue-0eb229.svg";